import { FacturaMetaData } from "../../models/RestModels";

export function getEmptyFacturaMetaData(): FacturaMetaData
{
		return {
			Fecha:'',
			total:'',
			noCertificado:'',
			moneda:'',
			lugarExpedicion:'',
			folio:'',
			rfcReceptor:'',
			receptor:'',
			rfcEmisor:'',
			emisor:'',
			UUID:'',
			domicilioReceptor:'',
			fechaTimbrado:'',
			regimenFiscalReceptor:'',
		} as FacturaMetaData;
}
